import React from 'react';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { formatCurrency, getTrimmedFirstString } from '../util';

class ServiceCredibility {
  getCachedCreditsafeDetails = async (organizationNumber) => {
    try {
      const response = await axios.get(
        '/api/creditsafe/cached-details',
        { params: { organizationNumber } }
      );
      return response?.data;
    } catch(error) {
      throw error;
    }
  }

  getCreditsafeDetails = async (organizationNumber) => {
    const response = await axios.get(
      '/api/creditsafe/details',
      { params: { organizationNumber } }
    );
    return response?.data;
  }

  downloadCreditsafePdf = async (orgNum) => {
    try {
      const res = await axios.get('/api/creditsafe/pdf', {
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
          'Content-Type': 'application/pdf',
        },
        params: { organizationNumber: orgNum },
      });
      return res;
    } catch (error) {
      throw(error);
    }
  }

  getCompanyData = async (orgNum, supplierId) => {
    try {
      return await axios.get(
        '/api/credibility/company',
        { params: { regNum: orgNum, supplierId } }
      );
    } catch (error) {
//      console.error('Company data fetch failed', error);
      return null;
    }
  };

  filterSynaCompanyData = (compData) => {
    const { Namnlista, Adresslista, Bolsate } = compData.Objekt?.Omfragad;
    const compObj = {
      name: Namnlista?.Namn?._text || '',
      kommun: (Bolsate?._text && getTrimmedFirstString(Bolsate._text)) || '',
      address: '',
      postnumber: '',
    };

    if (Adresslista) {
      let { Adress } = Adresslista;
      if (Array.isArray(Adress)) {
        Adress = Adress.find(address => address._attributes.typ === 'sate') || Adress[Adress.length-1]
      }
      compObj.address = `${Adress?.Gatabox?._text || ''}
${(Adress?.Postnr && Adress.Postnr._text+' ') || ''}${Adress?.Postort?._text || ''}`;
    }
    return compObj;
  };

  filterCreditsafeCompanyData = (compData) => {
    const { address, name } = compData;
    return {
      name,
      kommun: address?.city?.toString() || '',
      address: `${address?.street || ''}
${address?.postCode ? address.postCode+' ' : ''}${address?.city || ''}`,
      postnumber: address?.postCode,
    };
  };
}

export default new ServiceCredibility();
